import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  background: hsl(9, 48%, 95%);
  padding: 1rem;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  span {
    font-weight: bold;
    margin-bottom: 1rem;
  }
`;

const Section = styled.div`
  margin: 1rem;
  width: 100%;
  span {
    margin-left: 1rem;
  }
  p {
    margin-left: 1rem;
  }
  div {
    display: flex;
    align-items: center;
    margin: 0 1rem;
    margin-top: 1rem;
  }

  img {
    margin: 0 1rem;
    margin-top: 1rem;
  }
`;

const Background = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: red;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  width: 50px;
  height: 50px;
`;

const Image = styled.img`
  width: 50px;
  height: 50px;
`;

export { Section, Background, Image };

export default Container;
